import { AccountType } from "@boo/shared";

export const ACCOUNT_TYPE_LABELS: Record<AccountType, string> = {
  [AccountType.Bank]: "Bank",
  [AccountType.CreditCard]: "Credit card",
  [AccountType.Cash]: "Cash",
  [AccountType.EWallet]: "E-wallet",
};

export const INPUT_CLASS =
  "rounded-lg border border-border bg-transparent px-3 py-1.5 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/40";
